import { Modal } from 'react-bootstrap';
import { FilterRenameProps } from '../../../services/interface/bonds';
import { EXIST_LOCAL_STORAGE } from '../../../services/constants';
import { getStorage } from '../../../services/helperFunctions';
import { useState, useEffect, useRef, useCallback } from 'react';

const RenameFilter: React.FC<FilterRenameProps> = ({ showRename, toggle, renameFilter, filterRename, handleFilterListPagination }) => {
  const [filterName, setFilterName] = useState('');
  useEffect(() => {
    setFilterName(filterRename?.filter_name);
  }, [filterRename]);

  const handleSubmit = useCallback(
    (e: any) => {
      e.preventDefault();
      const UserId = getStorage(EXIST_LOCAL_STORAGE.USER_ID);
      const body: any = {
        search_filter_id: filterRename?.search_filter_id,
        user_id: UserId,
        filter_name: filterName,
      };

      renameFilter(body).then((data: any) => {
        toggle();
        handleFilterListPagination();
      });
    },
    [filterName, renameFilter, toggle, handleFilterListPagination]
  );

  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputRef.current && filterName !== '') {
      inputRef.current.focus();
    }
  }, [filterName]);

  return (
    <Modal
      show={showRename}
      onHide={toggle}
      size="sm"
      dialogClassName="modal-100w"
      centered
      aria-labelledby="example-custom-modal-styling-title-lg"
    >
      <Modal.Header closeButton className="bg-theme">
        <Modal.Title id="example-custom-modal-styling-title-lg" className="modal-heading h5">
          Rename Filter As
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12 text-center">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input
                  type="text"
                  ref={inputRef}
                  autoFocus
                  onChange={(event: any) => setFilterName(event?.target?.value)}
                  className="form-control"
                  value={filterName}
                  placeholder="Enter Filter Name"
                />
              </div>
              <button type="submit" className="btn btn-light border-dark btn-sm">
                Rename Filter
              </button>
            </form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RenameFilter;
